import InfoIcon from '@mui/icons-material/Info';
import StraightenIcon from '@mui/icons-material/Straighten';
import GrainIcon from '@mui/icons-material/Grain';

import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { memo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { InformationTooltip } from '../InformationTooltip';

export const AttributesTooltip = memo(function (): ReactElement {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <InformationTooltip
      tooltipElement={InfoIcon}
      fontSize={isMobile ? 'small' : 'medium'}
      tooltipContent={
        <Stack direction='column' spacing={1} width='auto'>
          <Typography variant='body1'>{t('attributes.tooltipTitle')}</Typography>
          <Divider />
          <List dense>
            <ListItem>
              <ListItemIcon>
                <StraightenIcon fontSize='large' htmlColor='black' />
              </ListItemIcon>
              <ListItemText
                primary={t('attributes.edge-sizes.displayName')}
                primaryTypographyProps={{ fontSize: 'large' }}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <GrainIcon fontSize='large' htmlColor='black' />
              </ListItemIcon>
              <ListItemText
                primary={t('attributes.soilClassification.displayName')}
                primaryTypographyProps={{ fontSize: 'large' }}
              />
            </ListItem>
          </List>
        </Stack>
      }
    />
  );
});
